// src/theme.ts
// import '@fontsource/inter-tight';
import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { 
      main: '#FE6F61', // Blue primary color
    },
    secondary: { 
      main: '#f97316', // Orange CTA
    },
    background: {
      default: '#FFFFFF', // Dark background
      paper: '#FFFFFF', // Paper background color
    },
  },
  typography: {
    fontFamily: '"Be Vietnam Pro", sans-serif',
    fontSize: 16,
    h1: {
      fontFamily: '"Be Vietnam Pro", sans-serif',
      fontWeight: 400,
    },
    h2: {
      fontFamily: '"Be Vietnam Pro", sans-serif',
      fontWeight: 400,
    },
    h3: {
      fontFamily: '"Be Vietnam Pro", sans-serif',
      fontWeight: 400,
    },
    h4: {
      fontFamily: '"Be Vietnam Pro", sans-serif',
      fontWeight: 400,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          padding: '8px 16px',
        },
      },
    },
  },
});
